import React from "react";

export const Raw = ({block}) => {
  return <p dangerouslySetInnerHTML={{__html: block.data.html}}/>
}